"use client";

import dynamic from "next/dynamic";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

import { env } from "./env";

import type { AnalyticsProviderClientStrategy } from "@workspace/analytics";

const isPostHogConfigured = Boolean(env.NEXT_PUBLIC_POSTHOG_KEY);
const postHogKey = env.NEXT_PUBLIC_POSTHOG_KEY;

const PageView = dynamic(
  () => import("./page-view").then((mod) => mod.PageView),
  {
    ssr: false,
  },
);

if (typeof window !== "undefined" && postHogKey) {
  posthog.init(postHogKey, {
    api_host: env.NEXT_PUBLIC_POSTHOG_HOST,
    person_profiles: "always",
    capture_pageview: false,
    disable_external_dependency_loading: true,
    disable_session_recording: true,
  });
}

export const strategy = {
  Provider: ({ children }) => {
    if (!isPostHogConfigured) {
      return children;
    }

    return (
      <PostHogProvider client={posthog}>
        {children}
        <PageView />
      </PostHogProvider>
    );
  },
  track: (event, properties) => {
    if (typeof window === "undefined" || !isPostHogConfigured) {
      return;
    }

    posthog.capture(event, properties);
  },
  identify: (userId, traits) => {
    if (typeof window === "undefined" || !isPostHogConfigured) {
      return;
    }

    posthog.identify(userId, traits);
  },
  reset: () => {
    if (typeof window === "undefined" || !isPostHogConfigured) {
      return;
    }

    posthog.reset();
  },
} satisfies AnalyticsProviderClientStrategy;
